import type { Product, Variant } from './types/product';

export type ProductVariantRow = {
  kind: 'variant';
  id: string;
  product: Product;
  variant: Variant;
};

export type ProductParentRow = {
  kind: 'parent';
  id: string;
  product: Product;
  children: ProductVariantRow[];
};

export type ProductSearchRow = ProductParentRow | ProductVariantRow;

export function toProductSearchRows(products: Product[] | undefined): ProductParentRow[] {
  return (products ?? []).map((product) => ({
    kind: 'parent',
    id: `product:${product.identifiers.sparklayer ?? product.identifiers.platform ?? product.slug}`,
    product,
    // A single variant parent is selected from its own row, so it gets no children.
    children:
      product.variants.length > 1
        ? product.variants.map((variant) => ({
            kind: 'variant' as const,
            id: `variant:${variant.identifiers.sku}`,
            product,
            variant,
          }))
        : [],
  }));
}

// The product endpoints only look parents up by their own identifiers, so a variant SKU, usually
// one taken from the URL, is resolved against a set of search results.
export function findParentByVariantSku(
  products: Product[] | undefined,
  sku: string | null,
): Product | null {
  if (!sku) {
    return null;
  }
  return (
    products?.find((product) =>
      product.variants.some((variant) => variant.identifiers.sku === sku),
    ) ?? null
  );
}
